import { DOTS_APP_QUERY_KEY } from "common/query-keys";
import { getDots } from "components/brands/brands.api";
import { useRequestProcessor } from "./useRequestProcessor";

// The brand's connected Dots app, or null when there isn't one. `getDots` resolves the raw
// AppResponse — success is false ("No Dots App was found.") when the brand has no app — and
// resolves undefined when the request itself failed, which we rethrow so callers can tell
// "no app" apart from "don't know yet".
//
// brandUserId is normalised to a string because it reaches this hook as a route param in
// some places and as a number off the brand record in others; React Query compares keys
// structurally, so [key, 123] and [key, "123"] would otherwise be two separate queries.
export const useGetBrandDotsApp = (brandUserId) => {
    const { useQuery } = useRequestProcessor();

    return useQuery(
        [DOTS_APP_QUERY_KEY, String(brandUserId)],
        () =>
            getDots(brandUserId).then((data) => {
                if (!data) {
                    throw new Error("Failed to load the brand's Dots app.");
                }

                return data.success && data.result?.id ? data.result : null;
            }),
        {
            enabled: !!brandUserId,
        },
    );
};

export default useGetBrandDotsApp;
